import React from "react";
import { Link } from "react-router-dom";
import { Users, Wallet, Settings, TrendingUp, Layers } from "lucide-react";
import { ADMIN_AFF } from "@/constants/testIds";

const CARDS = [
  { to: "/admin/affiliate/profiles", icon: Users, label: "Affiliate profiles", blurb: "Active affiliates, status, stats and tiers." },
  { to: "/admin/affiliate/ledger",   icon: Wallet, label: "Commission ledger", blurb: "Approve, void and review every commission event." },
  { to: "/admin/affiliate/payouts",  icon: TrendingUp, label: "Payouts",       blurb: "Batch approved entries. master_admin approves; admin marks paid." },
  { to: "/admin/affiliate/config",   icon: Settings, label: "Commission config", blurb: "Per-source commission %. master_admin only." },
  { to: "/admin/affiliate/tiers",    icon: Layers, label: "Tier thresholds",   blurb: "Lift-Off · Orbit · Galaxy · Cosmos promotion rules." },
];

export default function AdminAffiliateHome() {
  return (
    <div data-testid={ADMIN_AFF.home} className="space-y-8">
      <header className="fade-up">
        <div className="eyebrow">Affiliate admin</div>
        <h1 className="headline-xl">Affiliate command center</h1>
        <p className="text-lifted-dim mt-2 max-w-2xl">
          Every commission event flows here for human review. Nothing auto-pays.
        </p>
      </header>
      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
        {CARDS.map((c, i) => (
          <Link key={c.to} to={c.to} className={`glass-panel p-6 fade-up delay-${(i % 5) + 1} hover:-translate-y-1 hover:border-lifted-green/30 transition-transform`}>
            <div className="flex items-center gap-4">
              <div className="h-11 w-11 rounded-xl border border-lifted-green/30 bg-lifted-green/10 text-lifted-green flex items-center justify-center">
                <c.icon className="h-5 w-5" />
              </div>
              <div>
                <div className="font-anton text-xl uppercase">{c.label}</div>
                <div className="text-sm text-lifted-dim">{c.blurb}</div>
              </div>
            </div>
          </Link>
        ))}
      </div>
    </div>
  );
}
